import { BlueButton } from "@/components/generic/BlueButton"
import classes from "./HeaderButtonReferAFriend.module.css"

export function HeaderButtonReferAFriend() {
  return (
    <BlueButton data-testid="btn-refer-friend" aria-label="Refer a Friend" className={classes.button} leftSection={<span>🎁</span>}>
      Refer a Friend
    </BlueButton>
  )
}
